export default (state = [], action) => {
  switch (action.type){
    case 'SET_SEARCH':
		return {...state, searchString: action.search}
		//return action.search;
	case 'SET_FILTERPENDING':
		return {...state, filterPending:  action.filterpending}
	case 'SET_FILTERODOO':
		return {...state, filterOdoo:  action.filterOdoo}
	case 'SET_FILTERRATING':
		return {...state, filterRating:  action.filterRating}
    default:
          return state;
  }
};